import axios from '@/lib/AxApi';

export default {
    async getEventStatistics(params)
    {
        try
        {
            const response = await axios.get('/Statistics/getEventStatistics',
                {
                    params,
                });
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    }
};
